import "./Blog.css"
import { useNavigate } from 'react-router-dom'
import { posts } from "./Posts"

export const Blog = () => {
  const navigate = useNavigate();

  const handlePostClick = (slug) => {
    navigate(`/blog/${slug}`);
  };

  return (
    <div className="blog-container">
      <div className="blog-content">
        <h1>Blog</h1>
        <p className="blog-intro">
          Descubre consejos, guías y tendencias sobre moda de segunda mano
        </p>

        <div className="blog-grid">
          {posts.map((post, index) => (
            <div
              className="blog-card"
              key={index}
              onClick={() => handlePostClick(post.slug)}
            >
              <div className="blog-card-image">
                <img src={post.image} alt={post.title} />
              </div>
              <div className="blog-card-content">
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}
